import { Box, Flex, Menu, Text, Stack } from '@mantine/core'
import { IconBell } from '@tabler/icons'
import React, { useContext, useState, useEffect } from 'react'
import CommentsSection from '../CommentsSection'
import { BusinessNameNotification, FillIconNotification } from '../../../../../icons/x-symbol-svgrepo-com'
import IdeaContext from '../../../IdeaContext'
import SingleCustomerContext from '../../../../Customer360/Customer-Context/SingleCustomerContext'
import DiscoveryContext from '../../../../Discovery/DiscoveryContext'

const CommentsMenu = ({componentType = "idea"}: {componentType?: string}) => {

  const isIdeaPage: boolean = componentType === 'idea'
  const isDiscoveryPage: boolean = componentType === 'discovery'
  const isCustomerPage: boolean = componentType === 'customer'
  const parseQueryParams = (search: string) => {
    return new URLSearchParams(search);
  };
  const queryParams = parseQueryParams(location.search);
  const commentId = queryParams.get("commentId");

  const ContextToUse: React.Context<any> = 
  isIdeaPage ? IdeaContext : isDiscoveryPage ? DiscoveryContext : SingleCustomerContext;

  const { isCommentPresent,comments, setComments, getUnreadNotificationsCountByRequest,
    chosenEvidence, activityOpened, setActivityOpened } = useContext(ContextToUse);

  /* console.log({item}) */

  useEffect(() => {
    setComments(isCommentPresent || []);
  }, [isCommentPresent]);

  const commentExist = comments?.length > 0;
  useEffect(() => {
    if (commentId) {
      setActivityOpened(true);
    }
  }, [commentId]);
  
  return (
   
    <Menu opened={activityOpened} 
      position="left" 
      offset={isCustomerPage ? 52 : 35}
      styles={{
        dropdown: {
          position: 'fixed',
          zIndex: 1000,
          top: isCustomerPage ? '200px' : '10px',
          /* height: '99%', */
          overflow: 'hidden'
        }
      }}>
      <Menu.Target>
        <Flex align="center" w="107px" mr="12px" sx={{ cursor: "pointer" }}>
          <Box>
            {getUnreadNotificationsCountByRequest(chosenEvidence?._id) > 0 ? <BusinessNameNotification/> :  commentExist ? <FillIconNotification/> : <IconBell size={15} color="#5C5CEB" />}
          </Box>

          <Text ml="4px" fw={500} color="#5C5CEB" fz={12} lineClamp={1} onClick={()=>setActivityOpened((prev: boolean)=> !prev)}>
                Activity
          </Text>
        </Flex>
      </Menu.Target>

      <Menu.Dropdown p={0} m={0}>
        <Box>
          <CommentsSection 
            item={chosenEvidence} 
            setOpened={setActivityOpened} 
            componentType={componentType} 
            commentId={commentId}/>
        </Box>
      </Menu.Dropdown>
    </Menu>
   
  )
}

export default CommentsMenu